// extracted by mini-css-extract-plugin
export default {"burger-btn":"Cross_burger-btn__V-lU3","burger-span-top":"Cross_burger-span-top__QXfJH","burger-span-bottom":"Cross_burger-span-bottom__wyNT5"};